module.exports = __webpack_public_path__ + "img/lg_ring_r_i_1_1@2x.e952764f.png";